import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { documentApiService } from "@/features/documents/services/documentApiService";
import type { Document } from "openapi-client-sdk/document-api-client/dist";
import { DocumentEditor } from "@/features/documents/components/Editor/Editor";
import { Loader2 } from "lucide-react";
import { NotFound } from "@/components/NotFound";

export function DocumentPage() {
    const { documentId } = useParams<{ documentId: string }>();
    const [document, setDocument] = useState<Document | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadDocument = async () => {
            if (!documentId) {
                setError("No document ID provided");
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                setError(null);
                const doc = await documentApiService.getDocument(documentId);
                setDocument(doc);
            } catch (error) {
                console.error("Failed to load document:", error);
                setError(`Document with ID "${documentId}" was not found`);
            } finally {
                setIsLoading(false);
            }
        };

        loadDocument();
    }, [documentId]);

    return (
        <div>
            {isLoading && (
                <div className="flex items-center justify-center py-12">
                    <div className="flex items-center gap-2 text-md-on-surface-variant">
                        <Loader2 className="h-4 w-4 animate-spin" />
                        <span className="text-sm">Loading document...</span>
                    </div>
                </div>
            )}
            {!isLoading && error && (
                // <div className="flex items-center justify-center py-12">
                //     <div className="text-center">
                //         <p className="text-md-on-surface-variant">{error}</p>
                //     </div>
                // </div>
                <NotFound />
            )}
            {!isLoading && !error && document && (
                <DocumentEditor document={document} />
            )}
        </div>
    );
}
